
<template>
	<div class="triangle-rewards-card">
		<template v-if="handleOffersView">
			<div class="content">
				<img :alt="content.offers.rewards" :src="content.offers.top_picks_logo" class="logo" />
			</div>
		</template>
		<template v-else-if="handleDisplayRewardsView">
			<div class="content rewards_signin">
				<div class="message-box">
					<div :class="` ${language}`">
            <img :alt="content.offers.rewards" :src="content.offers.join_logo" />
            <div class="cta">
              <div class="cta-title">
                <h1>{{ content.offers.rewards_title_pre }}</h1>
                <h1>{{ content.offers.rewards_title_post }} <span class="registered-trademark">{{ content.offers.registered_trademark }}</span></h1>
              </div>
              <div class="cta-body">
                <p>{{ content.offers.rewards_text_pre }}</p>
                <p>{{ content.offers.rewards_text_post }}</p>
              </div>              
              <button v-on:click="openTriangleSignIn" v-if="!isLoggedIntoCT">{{ content.offers.signin }}</button>
                <div :class="['cta-join', language]">
                  <p>{{ content.offers.click_to_join }}</p>
                  <a :href="registrationUrl" target="_blank">{{ content.offers.join }}</a>
                </div>
            </div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";


export default {
	name: "TriangleRewardsCard",
	mixins: [blockElementMixin],
	data() {
		return {
			shouldApplyStyle: false
		}
	},
	created() {
		this.loadOffers();
		this.updateBlockClass();

		//window.addEventListener("resize", this.handleResize());
	},
	computed: {
		...mapGetters('ctUser', ['canViewTriangleRewards', 'isSignedIn', 'offerViewMode', 'hasOffers', 'isLoggedIntoCT', 'hasTriangleID', 'registrationUrl', 'triangleSignInUrl']),
		...mapGetters(['content', 'language']),
		isTuesday() {
			const today = new Date();
			const dayOfWeek = 2;
			return today.getDay() === dayOfWeek;
		},
		isPreviewFlyer() {
			return this.isLoggedIntoCT && this.hasTriangleID && this.offerViewMode === 'preview';
		},
		handleOffersView() {
			return this.isLoggedIntoCT && this.hasTriangleID && this.offerViewMode === 'live';
		},
		handleDisplayRewardsView() {
			return (!this.isLoggedIntoCT && !this.hasTriangleID) || (this.isLoggedIntoCT && !this.hasTriangleID) ||
				(this.isPreviewFlyer) || (this.isPreviewFlyer && this.isTuesday) || (!this.isLoggedIntoCT && this.hasTriangleID)
        }
	},
	mounted() {
    console.log('content', this.content);
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
	},
	methods: {
		...mapActions('ctUser', ['triggerUserDialog', 'updateOfferBlocks', 'loadOffers']),
		openTriangleSignIn() {
			window.open(this.triangleSignInUrl, '_blank');
		},
		getUrlParameter(name) {
			name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
			var results = regex.exec(window.location.search);
			return results === null
				? ""
				: decodeURIComponent(results[1].replace(/\+/g, " "));
		},
		updateBlockClass() {
			this.block.classes['noOffers'] = !this.hasOffers;
			this.block.classes['previewFlyer'] = this.isPreviewFlyer;
		},
		handleResize() {
      const noOffersRewards = document.querySelector(".flyer-block.TriangleRewardsCard.noOffers");
      const offersRewards = document.querySelector(".flyer-block.TriangleRewardsCard:not(.noOffers)");

      const parentSelector = "[mode=mobile] [page-id=triangleRewards].section-container";

			if (noOffersRewards) {
        const parent = noOffersRewards.closest(parentSelector);
        if (parent) {
          parent.style.gridTemplateRows = "repeat(3, 193.5px)";
        }
      }
      if (offersRewards) {
        const offersParent = offersRewards.closest(parentSelector);
        if (offersParent) {
          offersParent.style.gridTemplateRows = "repeat(6, 193.5px)";
        }
      }
    }
	},
	watch: {
		hasOffers() {
			this.updateBlockClass();
			//window.addEventListener("resize", this.handleResize());
		}
	}
}
</script>

<style lang="scss" scoped>
.triangle-rewards-card {
	display: flex;
	flex-direction: column;
	background-color: #fff;
	width: inherit;
	height: inherit;
	/* calc(16em * 0.8235);*/
	text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	z-index: 999;

	/*border: solid 1px #AEAEAE;*/
	.content {
		position: relative;
		display: flex;
		flex-direction: column;
		flex-basis: 100%;
		justify-content: center;
		align-items: center;
		text-align: center;

		.overlay {
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			position: absolute;
		}
	}

	.rewards_signin {
    .cta {
      position: absolute;
      max-width: 55%;
      top: 13%;
      right: 8%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .cta-title {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .cta-body {
      padding-top: 8px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .cta-join {
      padding-top: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 3px;

      &.en {
        flex-direction: row;
      }

      &.fr {
        flex-direction: column;
      }

      a {
        color: #fff;
      }
    }

		border: solid 1px #AEAEAE;

		h1 {
			color: #fff;
      font-size: 2.2em;
      line-height: 1.1;

      .registered-trademark {
        font-size: 0.2em;
        font-weight: 400;
        vertical-align: super;
      }
		}

		button {
      border: none;
      margin-top: 15px;
			background-color: #fff;
			color: #287d87;
			width: unset;
			min-height: unset;
			padding: 5px 30px 5px;
			font-size: 1.4em;
      font-weight: 600;
		}

    img {
      width: 100%;
      height: auto;
    }

		p {
      color: #fff;
		}

		.preview-message {
			margin: 1em 10em;
		}

		.message-join {
			font-weight: unset;
		}

		+.bands {
			height: 50px;
		}

	}

	.rewards_box {
		border: solid 1px #AEAEAE;
		padding-top: 2em;
    flex-basis: 15%;

		img {
			width: 45%;
			height: auto;
		}

		p {
			margin: 1em 6.5em;
		}

    .join_now{
      margin: 8px 0;
      color: #707070;
    }

		.rewards_graphic,
		span {
			transform: translateY(-35px);

		}
	}

	.logo {
		width: 100%;
	}

	.message-box {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.message {
		text-align: center;
		font-size: 1.2em;
		font-weight: 500;
	}

	.message-reveal {
		text-align: center;
		font-size: 1em;
		font-weight: 900;

		.fr {
			font-size: .9em;
		}
	}

	.message-reveal-fr {
		text-align: center;
		font-size: .9em;
		font-weight: 900;
	}

	.message-join {
		text-align: center;
		font-size: .7em;
		font-weight: 900;
		padding-bottom: 3px;
	}

	.fine-print {
		font-size: 0.4em;
	}

	.bands {
		display: flex;
		flex-direction: column;
    flex-basis:5%;
		justify-content: space-evenly;
		width: 100%;
		height: 1.3em;

		> :first-child {
			background-color: #EB2227;
		}

		> :nth-child(2) {
			background-color: #83142F;
		}

		> :last-child {
			background-color: #78CCC7;
		}

		>* {
			flex-grow: 1;
		}
	}
}
</style>
<style lang="scss">
[mode='mobile'] [page-id='triangleRewards'].section-container {
	position: relative;

	&>.flyer-block.TriangleRewardsCard.noOffers, &>.flyer-block.previewFlyer{
		// position: absolute;
		// z-index: 100;
		// top: 50%;
		// transform: translateY(-50%);
		// box-shadow: 0px 0px 16px 4px #20202042;
		grid-area: span 3 / span 2 / auto / auto !important;

	}

  &>.flyer-block.TriangleRewardsCard {
    grid-area: span 1 / span 2 / auto / auto !important;
  }

	&>.flyer-block.TriangleRewardsCard.noOffers {
    .cta {
      top: 17%;
    }
    .cta-title {
      h1 {
        font-size: 1.6em;
      }
    }
	}

	@-moz-document url-prefix() {
		.block.noOffers {
			position: absolute;
			bottom: 100%;
			transform: translateY(-300%);
		}
	}
}</style>
